export const initialCommissionModalState = {
  amount: '',
  currency: '',
  product: '',
  exchangeRate: '',
  comment: '',
  dateTime: '',
  walletId: '',
  id: '',
}
